var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'MainGroupbuyingsList'
      }
    }
  }, [_vm._v("總公司團購管理 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("上傳商品白名單")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v("上傳商品白名單")])])]), _c('div', [_c('b-form-group', {
    staticClass: "mt-2",
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label": "團購分店："
    }
  }, [_c('b-form-radio-group', {
    model: {
      value: _vm.form.branch_source,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "branch_source", $$v);
      },
      expression: "form.branch_source"
    }
  }, [_c('b-form-radio', {
    staticClass: "mb-2",
    attrs: {
      "value": _vm.BRANCH_SOURCE.ALL
    }
  }, [_vm._v("全部分店")]), _c('b-form-radio', {
    staticClass: "mb-2",
    attrs: {
      "value": _vm.BRANCH_SOURCE.CURRENT
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": "選擇分店",
      "size": "sm",
      "disabled": _vm.form.branch_source !== _vm.BRANCH_SOURCE.CURRENT
    },
    model: {
      value: _vm.form.branch_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "branch_ids", $$v);
      },
      expression: "form.branch_ids"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v("選擇分店 ")]), _vm._l(_vm.branchOptions, function (branch) {
    return _c('b-form-select-option', {
      key: branch.value,
      attrs: {
        "value": branch.value
      }
    }, [_vm._v(_vm._s(branch.text) + " ")]);
  })], 2)], 1), _c('b-form-radio', {
    attrs: {
      "value": _vm.BRANCH_SOURCE.EXCEL
    }
  }, [_c('div', {
    staticClass: "form-group d-inline-flex align-items-center"
  }, [_c('div', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("上傳分店")]), _c('b-form-file', {
    attrs: {
      "disabled": _vm.form.branch_source !== _vm.BRANCH_SOURCE.EXCEL,
      "name": "上傳分店",
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadBranches
    }
  })], 1), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/branch_list.xlsx"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案")])], 1)], 1)], 1), _c('b-form-group', {
    staticClass: "mt-2",
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label": "商品名單："
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-items-center"
  }, [_c('div', [_c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadProducts
    }
  })], 1), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/product_white_list.xlsx"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案")])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmitting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.isLoading || !_vm.isProductExcelLoaded,
      "busy": _vm.isLoading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm.isLoading ? _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  }) : _vm._e(), !_vm.isLoading ? _c('span', [_vm._v("送出")]) : _vm._e()])], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }